export type ActivitySection = 'report_problem' | 'find_service' | 'find_dealer' | 'find_spare_part' | 'our_contacts';
export type ActivityAction = 'open' | 'vin_search' | 'report_submit' | 'search' | 'nearby_open' | 'nearby_request'
  | 'region_select' | 'phone_picker' | 'phone_click' | 'route_click' | 'map_click' | 'site_click' | 'email_click' | 'request_submit';
export type TrackActivity = (section: ActivitySection, action: ActivityAction, target?: string) => void;
export const noActivity: TrackActivity = () => {};

/** Best-effort analytics: never delays navigation or affects the main request. */
export function createActivityTracker(auth: { initData?: string | null; accessToken?: string }): TrackActivity {
  return (section, action, target) => {
    if (!auth.initData && !auth.accessToken) return;
    try {
      const bytes = crypto.getRandomValues(new Uint8Array(16));
      bytes[6] = (bytes[6]! & 15) | 64;
      bytes[8] = (bytes[8]! & 63) | 128;
      const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
      const id = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
      const body = JSON.stringify({
        ...(auth.initData ? { initData: auth.initData } : { accessToken: auth.accessToken }),
        event: { id, section, action, ...(target ? { target } : {}) },
      });
      // The same event ID is reused for the only retry, so server-side counts remain idempotent.
      const send = async () => {
        for (let attempt = 0; attempt < 2; attempt++) {
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 5000);
          try {
            const res = await fetch('/api/activity.php', { method: 'POST', headers: { 'content-type': 'application/json' },
              body, keepalive: true, signal: controller.signal });
            if (res.ok || res.status < 500) return;
          } catch { /* A single network retry. No persistent queue with credentials. */ }
          finally { clearTimeout(timeout); }
        }
      };
      void send().catch(() => {});
    } catch { /* Missing crypto or browser restrictions must not break the mini-app. */ }
  };
}
